export default __webpack_public_path__ + "static/media/142-credit-salary.7396218a.svg";